export default defineNuxtRouteMiddleware((_to, _from) => {
  if (import.meta.client) {
    const { data, signOut } = useAuth()

    if (data?.value?.user?.admin === false) {
      signOut()
    }
  }
})
